import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/therapist_photo.png'


const _withScopeId = n => (_pushScopeId("data-v-67455b13"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "home" }
const _hoisted_2 = { class: "row no-margin" }
const _hoisted_3 = { class: "row main" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 col-md-4 text-right" }, [
  /*#__PURE__*/_createElementVNode("img", {
    id: "tp-photo",
    alt: "therapist photo",
    src: _imports_0
  })
], -1))
const _hoisted_5 = { class: "col-12 col-md-8 text-left text-description" }
const _hoisted_6 = {
  key: 0,
  id: "treatment-description-paragraph"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = { key: 1 }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Header, { menus: true }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("h2", null, _toDisplayString(_ctx.$t("HOME.HEADER")) + " " + _toDisplayString(_ctx.username) + "!", 1),
          (_ctx.treatmentSet)
            ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
                _createTextVNode(_toDisplayString(_ctx.$t("HOME.SENTENCE_1", { number: _ctx.numberOfModules })) + " ", 1),
                _hoisted_7,
                _createTextVNode(" " + _toDisplayString(_ctx.$t("HOME.SENTENCE_2")) + " ", 1),
                _hoisted_8,
                _createTextVNode(" " + _toDisplayString(_ctx.$t("HOME.SENTENCE_3")) + " ", 1),
                _hoisted_9,
                _createTextVNode(" " + _toDisplayString(_ctx.$t("HOME.SENTENCE_4")), 1)
              ]))
            : _createCommentVNode("", true),
          (!_ctx.treatmentSet)
            ? (_openBlock(), _createElementBlock("p", _hoisted_10, [
                _createTextVNode(_toDisplayString(_ctx.$t("HOME.TREATMENT_NOT_SET_1")) + " ", 1),
                _hoisted_11,
                _createTextVNode(" " + _toDisplayString(_ctx.$t("HOME.TREATMENT_NOT_SET_2")), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}